import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">
                itaobuyspread<span className="text-primary-300">.cam</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/50 leading-relaxed max-w-[240px]">
              La guida italiana per trovare i migliori prodotti online. Confronta, analizza e acquista in modo intelligente.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">Categorie</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Scarpe</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Felpe</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">T-Shirt</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Giacche</a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">Link Utili</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/guida-shopping" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Guida Shopping</Link>
              <Link to="/articolo/guida-completa-itaobuy-spreadsheet" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Guida Completa</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">itaobuy sheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Buy It Now</a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">Social</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Twitter / X</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Instagram</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">TikTok</a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10 text-center">
          <p className="text-7xl md:text-9xl font-heading font-extrabold text-background-50/5 select-none tracking-tighter">
            ITABUY
          </p>
          <p className="text-xs text-background-50/30 mt-4">
            &copy; 2026 itaobuyspread.cam — Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
}